export const statusTextPT: Record<string, string> = {
  'CRIAR': 'Em triagem',
  'CONFERIR': 'Em análise',
  'VERIFICAÇÃO PENDENTE': 'Aguardando verificação',
  'VERIFICAÇÃO ENVIADA': 'Aguardando verificação',
  'VERIFICAÇÃO APROVADA': 'Verificação aprovada',
  'VERIFICAÇÃO REJEITADA': 'Verificação rejeitada (via Uber)',
  'REJEITADO PELA EQUIPE': 'Rejeitado pela equipe (com motivo)',
  'DUPLICADA': 'Conta duplicada – sem possibilidade de ativação',
  'ATIVA EM ÉVORA': 'Sua ativação está em processo final',
  'EM TRANSFERÊNCIA': 'Sua ativação está em processo final',
  'ACEITAR CONVITE': 'Sua ativação está em processo final',
  'ENVIAR CDC': 'Sua ativação está em processo final',
  'ALTERAR P/BIKE': 'Sua ativação está em processo final',
  'CONFERIR SE ALTEROU P/BIKE': 'Sua ativação está em processo final',
  'ENTREGAR': 'Pronta para entrega, aguardo contato',
  'ATIVA': 'Conta finalizada e ativa na Uber',
  'DOCUMENTOS REJEITADOS': 'Documentos rejeitados (com motivo)',
  'DOCUMENTOS EXPIRADOS': 'Documentos vencidos (com motivo)',
  'SEM RESPOSTA': 'Aguardando resposta – cliente não retornou',
  'BLOQUEADA': 'Conta bloqueada pela Uber',
  'BANIDA': 'Conta banida permanentemente',
};

export const uiPT = {
  login: {
    title: 'Entrar no sistema',
    username: 'Usuário',
    password: 'Senha',
    button: 'Entrar',
    error: 'Usuário ou senha inválidos',
  },
  register: {
    title: 'Registro de Cliente',
    name: 'Nome',
    type: 'Tipo',
    courier: 'Entregador',
    driver: 'Motorista',
    modality: 'Modalidade',
    bike: 'Bicicleta',
    motorcycle: 'Motocicleta',
    phoneNumber: 'Telefone',
    IBAN: 'IBAN',
    idCard: 'Documento de Identidade',
    idCardFront: 'Frente do CC/TR/CPLP',
    idCardBack: 'Verso do CC/TR/CPLP',
    idCardPdf: 'CC/TR/CPLP em PDF',
    selfie: 'Selfie',
    modalityPhoto: 'FOTO DA MOCHILA',
    driverLicense: 'CARTA DE CONDUÇÃO (obrigatório para motocicleta)',
    city: 'Cidade',
    isReferred: 'Cliente é indicado por parceiro',
    submit: 'Registrar',
    success: 'Registro criado com sucesso! Guarde seu código de rastreamento:',
    error: 'Erro ao registrar. Verifique os campos e tente novamente.',
    caeDocument: 'Código de Atividade Económica (CAE)',
    taxClearanceDocument: 'Certidão de Não Dívida - Autoridade Tributária',
  },
  tracking: {
    title: 'Consulta de Status',
    trackingCode: 'Código de Rastreamento',
    name: 'Nome',
    button: 'Consultar',
    notFound: 'Registro não encontrado',
    status: 'Status',
    rejectionReason: 'Motivo da Rejeição',
    verificationLink: 'Link de Verificação',
    rejectedDocuments: 'Documentos Rejeitados',
    resubmitDocuments: 'Reenviar Documentos',
  },
  dashboard: {
    title: 'Painel de Clientes',
    search: 'Buscar por nome, código ou email',
    status: 'Status',
    actions: 'Ações',
    accept: 'Aceitar',
    reject: 'Rejeitar',
    reason: 'Motivo da Rejeição',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    edit: 'Editar',
    save: 'Salvar',
    users: 'Usuários',
    addUser: 'Adicionar Usuário',
    logout: 'Sair',
    updateStatus: 'Atualizar Status',
    verificationLink: 'Link de Verificação',
    rejectionReason: 'Motivo da Rejeição',
    rejectedDocuments: 'Documentos Rejeitados',
    selectRejectedDocuments: 'Selecionar Documentos Rejeitados',
    deleteConfirmTitle: 'Confirmar Exclusão',
    deleteConfirmMessage: 'Tem certeza que deseja deletar o cliente',
    deleteWarning: 'Esta ação não pode ser desfeita. Todos os documentos associados também serão removidos.',
    deleteSuccess: 'Cliente deletado com sucesso!',
    deleteError: 'Erro ao deletar cliente',
    deleting: 'Deletando...',
    // User delete translations
    deleteUserConfirmTitle: 'Confirmar Exclusão',
    deleteUserConfirmMessage: 'Tem certeza que deseja excluir o usuário',
    deleteUserWarning: 'Esta ação não pode ser desfeita.',
    deleteUserSuccess: 'Usuário deletado com sucesso!',
    deleteUserError: 'Erro ao deletar usuário',
    deletingUser: 'Excluindo...',
    selfie: 'Selfie',
    modalityPhoto: 'FOTO DA MOCHILA',
    driverLicense: 'CARTA DE CONDUÇÃO',
    idCardFront: 'Frente do CC/TR/CPLP',
    idCardBack: 'Verso do CC/TR/CPLP',
    idCardPdf: 'CC/TR/CPLP em PDF',
    caeDocument: 'Código de Atividade Económica (CAE)',
    taxClearanceDocument: 'Certidão de Não Dívida - Autoridade Tributária',
  },
  resubmit: {
    rejectedDocuments: 'Documentos Rejeitados',
    resubmitDocuments: 'Reenviar Documentos',
    resubmitTitle: 'Reenviar Documentos',
    resubmitDescription: 'Selecione os documentos que deseja reenviar',
    selectFile: 'Selecionar arquivo',
    resubmitSelected: 'Reenviar Documentos Selecionados',
    resubmitSuccess: 'Documentos reenviados com sucesso',
    resubmitError: 'Erro ao reenviar documentos',
    noRejectedDocuments: 'Nenhum documento rejeitado encontrado',
    clientNotFound: 'Cliente não encontrado ou código inválido',
    allDocumentsResubmitted: 'Todos os documentos foram resubmetidos com sucesso. Status alterado para "Em triagem".',
    partialResubmission: 'Documentos resubmetidos com sucesso. Ainda há documentos pendentes.',
  },
}; 